import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Button } from 'react-bootstrap';
import { AlertCircle, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './AccountDisabled.css';

const AccountDisabled = () => {
    const navigate = useNavigate();
    const { logout, user } = useAuth();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <div className="account-disabled-page">
            <Container className="d-flex justify-content-center align-items-center min-vh-100">
                <Card className="account-disabled-card text-center p-5 shadow-lg">
                    <Card.Body>
                        <div className="icon-container mb-4">
                            <AlertCircle size={80} className="text-warning" />
                        </div>
                        
                        <h2 className="mb-3">Account Access Restricted</h2>
                        
                        <p className="text-muted mb-4">
                            Your account (<strong>{user?.email}</strong>) does not have permission to access this admin panel.
                        </p>
                        
                        <div className="info-box mb-4 p-3 bg-light rounded">
                            <p className="mb-2">
                                <strong>Account Status:</strong> <span className="badge bg-warning text-dark">Restricted Access</span>
                            </p>
                        </div>
                        
                        <p className="text-muted small mb-4">
                            If you believe this is an error, please contact your system administrator or IT department to request appropriate access permissions.
                        </p>
                        
                        <Button 
                            variant="primary" 
                            size="lg" 
                            onClick={handleLogout}
                            className="d-flex align-items-center justify-content-center gap-2 mx-auto"
                        >
                            <LogOut size={20} />
                            Logout
                        </Button>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default AccountDisabled;
